import { Component , Inject, OnInit, ChangeDetectorRef , HostListener, Renderer2, ElementRef, ViewChild} from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { fader } from './shared/animation/animation';
import { GlobalService , LocalStorageService } from './services/index.service';
import { DOCUMENT } from '@angular/common';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { FinancialService } from './services/api/financial.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [fader],
})
export class AppComponent implements OnInit {
  public selectedItem?:any;
  public offsetTemp:null|number = null;
  public errObject:any;
  public currentPosition = 0;
  constructor(
    public global:GlobalService,
    public fincialService:FinancialService,
    private storage:LocalStorageService,
    private router: Router,
    private renderer:Renderer2,
    private el : ElementRef,
    @Inject(DOCUMENT) private document:Document,
    private DeviceDetectorService:DeviceDetectorService,
  ){ 
    router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe((event:any) => {
      const tempIdentity = sessionStorage.getItem('temp_identity');
      if (tempIdentity) {
        this.storage.setData('identity', JSON.parse(tempIdentity));
        sessionStorage.removeItem('temp_identity');
      }
      let token = this.storage.getData('token');
      let identity = this.storage.getData('identity');
      if(token && identity){
        this.fincialService.jwtService.pageStatue = router.navigated;
        this.fincialService.jwtService.TokenListener(token)
        this.fincialService.jwtService.balanceValueSub.subscribe(
          (value:any)=>{
            this.fincialService.setBalancedValue(value)
          }
        )
      }else{
        this.fincialService.jwtService.setLoggedIn(false)
        this.fincialService.jwtService.storage.removeItem('token')
        this.fincialService.jwtService.storage.removeItem('identity')
        this.fincialService.jwtService.storage.removeItem('pay')
      }
      if(router.navigated){
        this.global.animationTime = 600
      }
    });
    router.events.pipe(filter(event=>event instanceof NavigationEnd)).subscribe((e:any)=>{
      if(router.url==='/' || router.url==='/workshop' || router.url==='/team-building' || router.url==='/consult'){
        this.renderer.addClass(document.querySelector('#main'),'landing')
      }else{
        this.renderer.removeClass(document.querySelector('#main'),'landing')
      }
    })
  }
  getErrorServerStatus(){
    return this.fincialService.jwtService.getErrorServer()
  }
  Loading(){
    return this.global.getFullLoading()
  }
  prepareRoute(outlet:RouterOutlet){
    return outlet?.activatedRouteData?.animation;
  }
  ngOnInit(){
    this.googleAnalyticsDynmically()
    this.global.setDeviceDetector(this.DeviceDetectorService)
    
  }
  @HostListener('window:scroll', ['$event'])
  scrollTrigger(event: any) {
    let win = this.document.defaultView;
    this.offsetTemp = null;
    this.global.scrollTopValue.next(win?.pageYOffset as number)
    this.global.scrollVal = win?.pageYOffset || 0
    if(this.offsetTemp !== this.document.body.scrollHeight) {
      if ((win!.innerHeight + win!.pageYOffset + 700 >= this.document.body.scrollHeight)) {
        this.global.loadMoreTrigger.next('loadMore')
        this.offsetTemp = this.document.body.scrollHeight;
        this.global.setTouchScrollStatus(true)
      }
    }
  }
  @HostListener('window:popstate', ['$event'])
  onPopState() {
    this.global.scrollTop()
  }
  @HostListener('window:beforeunload')
  goToTopPage() {
    window.scroll(0,0)
  }
  
  googleAnalyticsDynmically(){
    if(environment.production && environment.mode.prod){
      // Create a script element with the src URL
      const script = this.renderer.createElement('script');
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-9EWC9M2TTH';
      // Optional: Add any additional attributes you want
      script.async = true;
      script.defer = true;
      this.renderer.appendChild(this.el.nativeElement.ownerDocument.head, script);
      // Append the script to the head
      const ga = this.renderer.createElement('script');
      ga.src = 'assets/js/analytics.min.js'
      this.renderer.appendChild(this.el.nativeElement.ownerDocument.head, ga);
    }
  } 
}